import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.first.login');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-first-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.first.login/view.scss */
:host {
  display: block;
  height: 100%;
}

.onboarding-page {
  min-height: 100svh;
  padding: 84px 24px 32px;
  color: #25324c;
  background: #f3f6fb;
}

.onboarding-shell {
  max-width: 800px;
  margin: 0 auto;
}

.onboarding-brand {
  display: flex;
  justify-content: center;
  margin-bottom: 28px;
}

.onboarding-brand img {
  width: 112px;
  height: auto;
}

.onboarding-card {
  border: 1px solid #e7edf6;
  border-radius: 28px;
  background: white;
  box-shadow: 0 20px 65px -30px rgba(35, 55, 103, 0.2);
  overflow: hidden;
}

.onboarding-steps {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 22px 30px;
  gap: 16px;
  border-bottom: 1px solid #e7edf6;
  background: #f8fafd;
}

.onboarding-steps li {
  display: flex;
  flex: 1;
  align-items: center;
  gap: 9px;
  color: #78889e;
  font-size: 12px;
}

.onboarding-steps li > span:first-child {
  flex: 0 0 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  border: 1px solid #dce4ef;
  border-radius: 50%;
}

.onboarding-steps .current {
  color: #285f93;
  font-weight: 700;
}

.onboarding-steps .current > span:first-child {
  color: white;
  background: #28689f;
  border-color: #28689f;
}

.onboarding-steps .complete > span:first-child {
  background: #eaf3fb;
}

.onboarding-body {
  padding: 34px 40px;
}

h1 {
  margin: 0 0 26px;
  font-size: 26px;
  color: #1d2c48;
  font-weight: 750;
}

form {
  max-width: 460px;
  margin: auto;
}

label {
  display: block;
  margin: 20px 0 9px;
  font-size: 13px;
  font-weight: 650;
}

input {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 52px;
  padding: 0 16px;
  border: 1px solid #e3e9f2;
  border-radius: 13px;
  background: #f7f9fc;
  color: #25324c;
  outline: none;
  font: inherit;
  font-size: 14px;
}

input:focus {
  border-color: #387dc1;
  box-shadow: 0 0 0 3px rgba(56, 125, 193, 0.1215686275);
}

input[readonly] {
  color: #697b94;
  background: #f0f3f8;
}

.primary {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 50px;
  margin-top: 28px;
  padding: 12px 22px;
  border: 0;
  border-radius: 25px;
  background: linear-gradient(105deg, #137db9, #303783);
  color: white;
  font-size: 14px;
  font-weight: 650;
  text-decoration: none;
  cursor: pointer;
}

.secondary {
  padding: 10px 0;
  border: 0;
  color: #326da5;
  background: transparent;
  font-size: 12px;
  cursor: pointer;
}

button:disabled {
  opacity: 0.6;
  cursor: wait;
}

button:focus-visible, a:focus-visible {
  outline: 2px solid #2685c0;
  outline-offset: 4px;
}

.hint {
  color: #748299;
  font-size: 12px;
  line-height: 1.7;
  margin-top: 10px;
}

.error {
  color: #b54747;
  font-size: 13px;
}

.otp-qr {
  display: block;
  width: 224px;
  max-width: 100%;
  margin: 20px auto;
}

.done {
  text-align: center;
}

.done > i {
  color: #298570;
  font-size: 28px;
  margin-bottom: 20px;
}

@media (max-width: 600px) {
  .onboarding-page {
    padding: 84px 14px 24px;
  }
  .onboarding-body {
    padding: 26px 22px;
  }
  .onboarding-steps {
    gap: 6px;
    padding: 18px 12px;
  }
  .onboarding-steps li {
    flex-direction: column;
    text-align: center;
    font-size: 10px;
  }
  h1 {
    font-size: 23px;
  }
  input {
    font-size: 16px;
  }
}
.privacy-policy-section {
  margin-top: 29px;
}

.privacy-policy-heading {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.privacy-policy-heading h2 {
  margin: 0;
  color: #2b3c57;
  font-size: 15px;
  line-height: 1.7;
  font-weight: 700;
  letter-spacing: -0.3px;
}

.privacy-policy-text {
  margin: 11px 0 0;
  color: #637188;
  font-size: 13px;
  line-height: 1.9;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.privacy-data-list {
  margin: 17px 0 0;
  padding: 0 18px;
  border: 1px solid #e9eef5;
  border-radius: 16px;
  background: #f8fafd;
  list-style: none;
}

.privacy-data-list li {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding: 17px 0;
}

.privacy-data-list li + li {
  border-top: 1px solid #e6ecf4;
}

.privacy-data-icon {
  display: flex;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  height: 32px;
  border: 1px solid #e1e9f4;
  border-radius: 10px;
  color: #658bb3;
  background: #fff;
  font-size: 13px;
}

.privacy-data-list h3 {
  margin: 0 0 5px;
  color: #384c6a;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.5;
}

.privacy-data-list p {
  margin: 0;
  color: #738097;
  font-size: 12px;
  line-height: 1.8;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.privacy-retention {
  margin-top: 25px;
}

.email-countdown {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #326da5;
  font-size: 12px;
}

.email-countdown strong {
  margin-left: 3px;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.email-expired {
  color: #b43b40;
  font-size: 12px;
  line-height: 1.6;
}

.email-code-hint {
  margin-top: 9px;
  color: #7a889d;
  font-size: 12px;
}`],
})
export class PageFirstLoginComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }
    public step = 'loading';
    public busy = false;
    public accountName = '';
    public email = '';
    public onetimepass = '';
    public profile: any = { first_name: '', last_name: '', institution: '', department: '' };
    public currentPassword = '';
    public passwordOtp = '';
    public passwordOtpRequirement = 'unknown';
    public passwordOptionsLoading = false;
    private passwordOptionsVersion = 0;
    public newPassword = '';
    public confirmPassword = '';
    public qrCodeImage = '';
    public otpReady = false;
    public setupError = '';
    public labels = ['개인정보 동의', '이메일 인증', '계정 정보 입력', '비밀번호 설정', 'OTP 등록'];

    public get stepNumber() {
        return ({consent: 1, email: 2, verify: 2, profile: 3, password: 4, otp: 5, done: 5})[this.step] || 1;
    }

    public emailSeconds: number | null = null;
    private emailDeadline = 0;
    private emailTimer: ReturnType<typeof setInterval> | null = null;
    private emailClockDestroyed = false;

    public get emailTimeLeft(): string {
        const seconds = this.emailSeconds ?? 0;
        return `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
    }

    private stopEmailClock(reset = true) {
        if (this.emailTimer !== null) clearInterval(this.emailTimer);
        this.emailTimer = null;
        if (reset) this.emailSeconds = null;
    }

    private syncEmailClock(data: any) {
        this.stopEmailClock();
        if (this.emailClockDestroyed || typeof data?.email_code_expires_at !== 'number'
            || typeof data?.server_time !== 'number'
            || !Number.isFinite(data.email_code_expires_at) || !Number.isFinite(data.server_time)) return;
        // Use server-relative time; browser clock skew and delayed interval callbacks
        // cannot restart the server-issued verification window or slow the countdown.
        this.emailDeadline = performance.now() + Math.max(0, data.email_code_expires_at - data.server_time) * 1000;
        const tick = () => {
            this.emailSeconds = Math.max(0, Math.ceil((this.emailDeadline - performance.now()) / 1000));
            if (this.emailSeconds === 0) this.stopEmailClock(false);
            this.service.render();
        };
        tick();
        if (this.emailSeconds > 0) this.emailTimer = setInterval(tick, 1000);
    }

    public ngOnDestroy() {
        this.emailClockDestroyed = true;
        this.passwordOptionsVersion++;
        this.stopEmailClock();
    }

    public async ngOnInit() {
        await this.service.init();
        this.service.loading.hide();
        await this.request('getSessionInfo');
    }
    private apply(data: any) {
        const enteringPassword = data.step === 'password'
            && (this.step !== 'password' || this.accountName !== data.account_name);
        this.step = data.step;
        this.syncEmailClock(data);
        this.accountName = data.account_name;
        this.email = data.email;
        this.profile = data.profile;
        this.otpReady = data.otp_ready;
        this.qrCodeImage = data.qr_code_image || '';
        this.setupError = data.setup_error || '';
        if (enteringPassword) void this.loadPasswordOptions();
    }
    private async loadPasswordOptions() {
        const version = ++this.passwordOptionsVersion;
        const account = this.accountName;
        this.passwordOtpRequirement = 'unknown';
        this.passwordOptionsLoading = true;
        let requirement = 'unknown';
        try {
            const response = await wiz.call('getSessionInfo', { password_options: '1' }, { timeout: 6000 });
            const data = response?.data;
            if (response?.code === 200 && data?.step === 'password' && data?.account_name === account
                && ['required', 'not_required', 'unknown'].includes(data?.password_otp)) {
                requirement = data.password_otp;
            }
        } catch (error) {
            // Keep optional input available when the advisory lookup is unavailable.
        } finally {
            if (!this.emailClockDestroyed && version === this.passwordOptionsVersion) {
                this.passwordOptionsLoading = false;
                if (this.step === 'password' && this.accountName === account) {
                    this.passwordOtpRequirement = requirement;
                    if (requirement === 'not_required') this.passwordOtp = '';
                }
                await this.service.render();
            }
        }
    }
    private async request(action: string, params: any = {}) {
        if (this.busy) return;
        this.busy = true;
        this.service.loading.show();
        let response: any;
        try {
            response = await wiz.call(action, params, { timeout: 135000 });
        } catch (error) {
            response = null;
        } finally {
            this.busy = false;
            this.service.loading.hide();
        }
        if (!response || response.code !== 200) {
            await this.service.alert.error(response?.data || '요청에 실패했습니다. 다시 시도해주세요.');
            if (response?.code === 401) location.href = '/login';
            else if (action === 'set_password' && this.step === 'password') void this.loadPasswordOptions();
            return;
        }
        if (action === 'emailAuthentication') this.onetimepass = '';
        if (response.data.completed) {
            if (response.data.notification_sent === false) await this.service.alert.error('설정은 완료되었지만 안내 메일을 보내지 못했습니다. 관리자에게 문의해주세요.');
            this.stopEmailClock();
            this.step = 'done';
            this.qrCodeImage = '';
            this.onetimepass = '';
        } else {
            this.apply(response.data);
        }
        await this.service.render();
    }
    public async onEmailChanged() {
        this.onetimepass = '';
        if (this.step === 'verify') this.step = 'email';
        this.stopEmailClock();
        await this.service.render();
    }
    public async agreeConsent() { await this.request('agree'); }
    public async sendVerification() { await this.request('emailAuthentication', { email: this.email }); }
    public async verifyCode() { await this.request('emailVerify', { onetimepass: this.onetimepass, email: this.email }); this.onetimepass = ''; }
    public async saveProfile() { await this.request('save_profile', this.profile); }
    public async setPassword() {
        if (this.passwordOptionsLoading) return;
        if (this.passwordOtpRequirement === 'required' && !/^[0-9]{6}$/.test(this.passwordOtp)) {
            await this.service.alert.error('기존 OTP 인증번호 6자리를 입력해주세요.');
            return;
        }
        if (this.newPassword !== this.confirmPassword) {
            await this.service.alert.error('비밀번호가 일치하지 않습니다.');
            return;
        }
        await this.request('set_password', { current_password: this.currentPassword, new_password: this.newPassword, otp: this.passwordOtpRequirement === 'not_required' ? '' : this.passwordOtp });
        if (this.step === 'otp') this.currentPassword = this.passwordOtp = this.newPassword = this.confirmPassword = '';
    }
    public async issueOtp() { await this.request('issue_otp'); }
    public async complete() { await this.request('complete', { onetimepass: this.onetimepass }); }
}

export default PageFirstLoginComponent;